import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterOutlinedWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.2505 1.5H9.7505L5.993 6.225L2.2505 1.5ZM0.188 1.2075C1.703 3.15 4.5005 6.75 4.5005 6.75V11.25C4.5005 11.6625 4.838 12 5.2505 12H6.7505C7.163 12 7.5005 11.6625 7.5005 11.25V6.75C7.5005 6.75 10.2905 3.15 11.8055 1.2075C12.188 0.7125 11.8355 0 11.213 0H0.7805C0.158 0 -0.1945 0.7125 0.188 1.2075Z",
		fill: "#fff"
	})
});
export default SvgFilterOutlinedWhite;
